import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { of } from 'rxjs';
import { Poi } from '../core/poi/poi.model';

@Injectable()
export class PoiCarouselResolver implements Resolve<Poi[]> {
  constructor(private service: ApiService) {}

  resolve() {
    return this.service.getPoiCarousel().pipe(
      first(),
      catchError((err) => {
        console.error('Non è stato possibile recuperare la lista di POI');
        return of(err);
      })
    );
  }
}
